const trains = {
  train: "火车", // translated
  trains: "火车", // translated
  fairConditions: "公平的条件", // translated
  to: "到", // translated
  earlier: "早些时候", // translated
  later: "之后", // translated
  adults: "成年人", // translated
  child: "孩子", // translated
  senior: "高级的", // translated
  seniors: "老年人", // translated
  price: "价格", // translated
  for: "为了", // translated
  total: "全部的", // translated
  selected: "已选择", // translated
  prebook: "预售书", // translated
  book: "书", // translated
  payment: "支付", // translated
  return: "返回", // translated
  passengers: "乘客", // translated
  delivery: "送货", // translated
  summary: "概括", // translated
  checkout: "查看", // translated
  trainToastCorrectFillForm: "请正确填写所有字段。", // translated
  fareConditions: "票价条件", // translated
  travelInfo: "旅游信息", // translated
  remarks: "客户备注", // translated
  noServices: "无服务", // translated
  timesAndSeats: "时间及座位", // translated
  mobileTicket: "手机票", // translated
  stationTicket: "车站领取", // translated
  homeTicket: "在家打印", // translated
  countryCode: "国家代码", // translated
  chooseTicket: "选择门票交付方式", // translated
  ticketError: "请选择前往所有目的地的机票", // translated
  ticketDelivery: "请选择门票递送方式", // translated
  passengerDetails: "乘客详细信息", // translated
  waitWhileProcessingPayment: "我们正在处理您的付款，请稍候，请勿刷新或关闭页面。", // translated
  reductionCardId: "减卡ID", // translated
  countryOfResidence: "居住国家", // translated
  countryOfBirth: "出生国家", // translated
  documentCountry: "文件国家", // translated
  documentNumber: "文件号码", // translated
  expirationDate: "截止日期", // translated
  documentType: "文件类型", // translated
  travelerDocumentInfo: "旅客证件信息", // translated
  youth: "青年", // translated
  youths: "青少年组", // translated
  departTimeEarlyFirst: "出发时间（最早到先）", // translated
};


export default trains;
